import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49637b70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "manifold m-current-price"
}

import { computed } from "@vue/runtime-core";
import { ethers } from "ethers";
import { useStore } from "@/composables/useStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrentPrice',
  setup(__props) {

const store = useStore();
const price = computed(() => {
  return ethers.utils.formatUnits(store.price.toString(), "ether");
});

return (_ctx: any,_cache: any) => {
  return (_unref(store).loaded && !_unref(store).saleHasEnded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(price)), 1))
    : _createCommentVNode("", true)
}
}

})